"use strict";

exports.__esModule = true;
exports.ImageElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "ImageElement__ImageContainer",
  componentId: "sc-z3oftn-0"
})(["position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;overflow:hidden;"]);
var Image = _styledComponents["default"].img.withConfig({
  displayName: "ImageElement__Image",
  componentId: "sc-z3oftn-1"
})(["z-index:1;width:100%;height:100%;"]);

/**
 * Displays image element widget.
 */
var ImageElement = exports.ImageElement = /*#__PURE__*/function (_Component) {
  function ImageElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ImageElement, _Component);
  var _proto = ImageElement.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      image = _this$props.image,
      opacity = _this$props.opacity,
      imageFit = _this$props.imageFit;
    return /*#__PURE__*/_react["default"].createElement(ImageContainer, null, /*#__PURE__*/_react["default"].createElement(Image, {
      "data-testid": "ImageElement.image",
      src: image,
      style: {
        opacity: (opacity ? opacity : 100) + "%",
        objectFit: imageFit ? imageFit : "cover"
      }
    }));
  };
  return ImageElement;
}(_react.Component);